import { render, staticRenderFns } from "./GetSchoolArmsRecordAxios.vue?vue&type=template&id=c8e2a1a2&"
import script from "./GetSchoolArmsRecordAxios.vue?vue&type=script&lang=js&"
export * from "./GetSchoolArmsRecordAxios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports